
export const NameTags = {
	currency_code: {
    en: "Currency Code",
    ko: "통화 코드",
    zh: "货币代码"
  },
  currency_name: {
    en: "Currency Name",
    ko: "통화 이름",
    zh: "货币名称"
  },
  currency_symbol: {
    en: "Currency Symbol",
    ko: "통화 심볼",
    zh: "货币符号"
  },
	last_update: {
		en: "Last Update",
    ko: "최종 업데이트",
    zh: "上次更新"
	}, 
	next_update: {
		en: "Next Update",
    ko: "다음 업데이트",
    zh: "下次更新"
	},
  country: {
    en: "Country",
    ko: "국가",
    zh: "国家",
  },
  currency_name_code: {
    en: "Currency Name & Code",
    ko: "통화명 및 코드",
    zh: "货币名称和代码",
  },
  exchange_rate: {
    en: "Exchange Rate",
    ko: "환율",
    zh: "汇率",
  },
}